export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8069.56879ea5.jpg";